import React, { useState } from 'react';
import { Bot, LockKeyhole } from 'lucide-react';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';

export const PermissionRequestDialog = ({ review, busy, close, save, t }) => {
  const [acknowledged, setAcknowledged] = useState(false);
  return <Dialog open onOpenChange={open => { if (!open && !busy) close(); }}>
    <DialogContent className="bot-permission-dialog" data-testid="bot-permission-dialog" closeTestId="bot-permission-dialog-close">
      <DialogHeader>
        <DialogTitle data-testid="bot-permission-dialog-title">{t.modalTitle}</DialogTitle>
        <DialogDescription data-testid="bot-permission-dialog-description">{t.modalDescription}</DialogDescription>
      </DialogHeader>
      <p className="bot-permission-lock" data-testid="bot-permission-dialog-lock"><LockKeyhole size={17} aria-hidden="true" />{t.locked}</p>
      <div><h3 data-testid="bot-permission-dialog-scope">{t.list} ({review.followed_bots.length})</h3>
        <ul className="bot-permission-bot-list" data-testid="bot-permission-review-list">{review.followed_bots.map(bot =>
          <li key={bot.id} data-testid={`bot-permission-review-${bot.id}`}><Bot size={18} aria-hidden="true" /><span>{bot.name}</span><small>{bot.activity === 'paper' ? t.paper : t.demo}</small></li>
        )}</ul>
      </div>
      <p data-testid="bot-permission-future-scope">{t.future}</p>
      <p data-testid="bot-permission-risk">{t.risk}</p>
      <label className="bot-permission-ack" htmlFor="bot-permission-ack" data-testid="bot-permission-ack-label">
        <Checkbox id="bot-permission-ack" data-testid="bot-permission-ack" checked={acknowledged} disabled={busy} onCheckedChange={value => setAcknowledged(value === true)} />
        <span>{t.acknowledgement}</span>
      </label>
      <DialogFooter>
        <Button variant="outline" disabled={busy} onClick={close} data-testid="bot-permission-cancel">{t.cancel}</Button>
        <Button className="bot-permission-primary" disabled={!acknowledged || busy || !review.can_request || !review.followed_bots.length} onClick={() => save(false)} data-testid="bot-permission-confirm">{busy ? t.saving : t.confirm}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>;
};